import { useSizeGuide } from "./use-size-guide";
import { useTranslate } from "@made-people/grease-translations";

interface SizeGuideFooterProps {
  className?: string;
}

export const SizeGuideFooter = ({
  className = "py-6",
}: SizeGuideFooterProps) => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  if (!sizeGuide) return null;

  return (
    <div className={className}>
      <p>{translate("Size_Guide_Footer_Text")}</p>
    </div>
  );
};
